import React from "react";
import { Card, CardHeader, makeStyles, IconButton, Grid, Avatar } from "@material-ui/core";
import { HtmlTooltip } from "../Utils";
import DragHandleIcon from '@material-ui/icons/DragHandle';
import PropTypes from "prop-types";
import {Color} from '../Constants';
import { grey, yellow } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    card: {
        margin: 5, 
        minHeight: 50,
        backgroundColor: Color.lightGreen
    },
    icon: {
        padding: 2
    },
    griditem: {
        cursor: 'move'
    },
    avatar: {
        backgroundColor: yellow[500],
        color: grey[900]
    },
}));

const Block = ({ forwardedRef, ...props }) => {
    const classes = useStyles();

    const {data, index, style} = props;

    return (
        <Grid item xl={3} lg={3} xs={6}>
            <Card 
                ref={forwardedRef}
                className={classes.card}
                style={style}>
                <CardHeader 
                    avatar={
                        <Avatar aria-label="recipe" className={classes.avatar}>
                            {`${index}`}
                        </Avatar>
                    }
                    title={`${data.store_name}`}
                    subheader={`${data.route_name}`}
                    className={classes.griditem}
                    titleTypographyProps={{align: 'left'}}
                    subheaderTypographyProps={{align: 'left'}}
                    action={
                        <HtmlTooltip title={`Drag to Re-order`}>
                            <IconButton size="small" className={classes.icon}>
                                <DragHandleIcon />
                            </IconButton>
                        </HtmlTooltip>
                    }/>
            </Card>
        </Grid>
    );
};

Block.propTypes = {
    data: PropTypes.object.isRequired,
};


export default Block;